import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';
import { Location } from '../../../../core/models/location.interface';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LocationService } from '../../../../core/services/location/location-service';
import { LoadingService } from '../../../../core/services/loading/loading';
import { Title } from '@angular/platform-browser';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { LocationForm } from '../location-form/location-form';

@Component({
  selector: 'app-location-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search,
  ],
  templateUrl: './location-list.html',
  styleUrl: './location-list.scss',
})
export class LocationList {
  public page = 1;
  total: number = 0;
  limit: number = 10;
  locations: Location[] = [];
  asyncLocations!: Observable<Location[]>;
  buscarlocation: string = '';
  @Input() filtro: string = '';
  @Input() orden: string = '';
  showColumns: string[] = [
    'acciones',
    'id',
    'countryCode',
    'country',
    'departmentCode',
    'department',
    'cityCode',
    'city',
  ];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private locationService: LocationService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Ubicaciones');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchLocation(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();
  }

  fetchLocation(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncLocations = this.locationService.getLocation(params).pipe(
      tap((data) => {
        this.locations = data.results;
        this.locationService.setLocation(data.results[0]);
        this.locationService.setLocations(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createLocation() {
    this.locationService.removeLocationSelected();
    const dialogRef = this.dialog.open(LocationForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchLocation(this.page);
    });
  }

  updateLocation(location: Location) {
    this.locationService.setLocation(location);
    const dialogRef = this.dialog.open(LocationForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchLocation(this.page);
    });
  }

  eliminate(location: Location): void {
    const confirmed = window.confirm(`¿Estás seguro de eliminar el registro: ${location.department}?`);
    if (!confirmed) return;
    this.locationService.delete(location.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchLocation(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
